




































































import Vue from 'vue';
import Component from 'vue-class-component';
import AuthService from '@/services/AuthService';

@Component({})
export default class ResetPassword extends Vue {
  protected token: string = '';
  protected username: string = '';
  protected newPass: string = '';
  protected newPassConfirmation: string = '';
  protected validationErrors: string[] = [];

  protected created() {
    // Retrieve token from URL.
    this.token = this.$route.params.token;

    // Add a nice background to the page.
    document.body.classList.add('body-pattern');
  }

  protected beforeDestroy() {
    document.body.classList.remove('body-pattern');
  }


  protected attemptPasswordReset() {
    AuthService.resetPassword(this.username, this.newPass, this.newPassConfirmation, this.token)
      .then(() => this.$router.push('/'))
      .catch((error) => {
        // If the error is a validation error, show an alert with the validation errors.
        if (error.response.status === 422) {
          const message = this.parseValidationError(error.response.data.errors);
          if (message.length > 0) {
            this.validationErrors = message;
          }
        }
      });
  }

  protected parseValidationError(errorsObject: any): string[] {
    const message = [];

    for (const key in errorsObject) {
      if (errorsObject.hasOwnProperty(key)) {
        message.push(errorsObject[key][0]);
      }
    }

    return message;
  }
}
